import React, { createContext, useState } from "react";
import * as auth from "./auth";
//import LoadingPage from "../components/LoadingPage";

export const AuthenticationContext = createContext();

const AuthProvider = (props) => {
  const [user, setUser] = useState(null);
  const [fetched, setFetched] = useState(false);
  
  const login = (username, password) => {
    return auth.login(username, password).then(data => {
      setUser(data.data);
    });
  };

  const logout = async () => {
    setUser(null);
    await auth.logout();
  };

  const getUser = async () => {
    const user = await auth.getUser();
    setUser(user ? user.data : null);
  };

  if (!fetched) {
    getUser().then(() => setFetched(true));
  }

  if (!fetched) {
    //return <LoadingPage />;
  }

  return (
    <AuthenticationContext.Provider
      value={{
        user,
        login,
        logout,
        getUser,
        setUser
      }}
    >
      {props.children}
    </AuthenticationContext.Provider>
  );
};

export { AuthProvider };
